import {
  FieldBuilder,
  FieldDefinition,
  MenuCategories,
  MenuSubcategories,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  LocationTypes,
} from '@zendra/shared';
import { LocationService } from 'cbd-proxies';
import { WoodCertificationService } from '../../proxy/geographic/controllers';

FieldBuilder.setNamespace('Geographic');

export const CERTIFIEDTHIRDPARTYPROPERTY_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('woodCertificationId', 'Entity.WoodCertification', WoodCertificationService)
    .required()
    .display('name')
    .displayFromNested('woodCertificationName')
    .sortBy('woodCertificationName')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('locationId', 'Entity.ThirdPartyProperty', LocationService)
    .display('name')
    .displayFromNested('locationName')
    .sortBy('locationName')
    .queryFilter({ locationTypeEntityName: LocationTypes.ThirdPartyProperty })
    .required()
    .build(),
  FieldBuilder
    .date('addedDate', 'Entity.WoodCertificationDetail.AddedDate')
    .required()
    .build()
];

export const CERTIFIEDTHIRDPARTYPROPERTY_CONFIG = {
  entityName: 'CertifiedThirdPartyProperty',
  localizationKey: 'Geographic::WoodCertificationDetail.CertifiedThirdPartyProperty',
  fields: CERTIFIEDTHIRDPARTYPROPERTY_FIELDS,
  permission: 'PlanningGeography.WoodCertificationDetails',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
